import { Box, Button, Divider, styled, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { PaymentChannelStatus } from '../../../elibrary/elibrary-system/element/PaymentCart'
import StateComponents from '../../../../components/state-component/StateComponents';
import { CURRENCY, currency_options } from '../enum';
import { booking_classroom_payment_data, BookingMeetingRoomFront } from '../../../../api/booking-meeting-room-front/booking_meeting_room_front.api';
import clsx from 'clsx';
import ImageTracking from '../../../../components/upload/MultiUploadFile';
import moment from 'moment';
import { alertError, alertSuccess } from '../../../../components/alert/swal';
import { useDispatch } from 'react-redux';
import { setLoading, unsetLoading } from '../../../../store/loading/loading.slice';
import { useNavigate } from 'react-router-dom';
import { routeName } from '../../../../routes/routeName';
import { useTranslation } from 'react-i18next';

type Props = {
    payment_icon_url: string;
    payment_name: string;
    payment_name_en: string;
    payment_no: string;
    payment_type: string;


    id_meeting_room: number;
    disabled?: boolean;
    hidden_button?: boolean;
}

const BoxCustom = styled(Box, {
    shouldForwardProp: (prop) => prop !== "noBg",
})<{ noBg?: boolean }>(({ theme, noBg }) => ({
    backgroundColor: noBg ? "transparent" : "#F6F6F6",
    padding: "40px",
    borderRadius: "16px",
    minHeight: "780px",
    border: "2px solid #DDE1EB",
    [theme.breakpoints.down("md")]: {
        padding: "1.2em",
    },
}));

const PaymentBookingMeetingRoom: React.FC<Props> = ({
    payment_icon_url,
    payment_name,
    payment_name_en,
    payment_no,
    payment_type,
    id_meeting_room,
    disabled,
    hidden_button

}: Props) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [formState, setFormState] = useState<booking_classroom_payment_data>({
        currency: "",
        id_files_payment: [],
        id_meeting_room,
        meeting_room_payment_time: "",
        meeting_room_payment_amount: 0,
        meeting_room_payment_date: ""
    })

    const [data_detail, set_data_detail] = useState<any[]>([]);
    const [currency_option, set_currency_option] = useState<string>(CURRENCY.THB);
    const [payment_file, set_payment_file] = useState<any[]>([]);
    const [payment_file_api, set_payment_file_api] = useState<any[]>([]);
    const [id_meeting_room_payment, set_id_meeting_room_payment] = useState<number | null>(null);


    const handleChangeFormState = (field: keyof booking_classroom_payment_data, value: any) => {
        setFormState((prev) => ({ ...prev, [field]: value }))
    }

    const handleDeleteByFileByIndex = (index: number, is_api?: boolean) => {
        if (is_api) {
            set_payment_file_api((prev) => prev.filter((_, i) => i !== index))
        } else {
            set_payment_file((prev) => prev.filter((_, i) => i !== index))
        }
    }
    const handleChangePaymentFile = (newFile: any) => {
        const newArray = Array.isArray(newFile) ? newFile : [newFile];
        if (newFile?.length > 0) {
            set_payment_file([...payment_file, ...newArray]);
        } else {
            set_payment_file([...payment_file, newFile]);
        }
    };

    const handleGetBookingMeetingRoomFrontPayment = async () => {
        await BookingMeetingRoomFront.findOnePayment(id_meeting_room).then((res) => {
            if (res.status < 300) {
                const response = res.data?.data || null;
                const details = response?.details || [];
                set_data_detail(details);
                set_payment_file_api(response?.files?.map((list: any) => {
                    return {
                        ...list,
                        file_path: `${list?.file_path}${list?.file_name}`,
                        is_image: true
                    }
                }) || []);
                if (response?.detail_payment) {
                    const meeting_room_payment_time = response?.detail_payment?.meeting_room_payment_date ? moment(response?.detail_payment?.meeting_room_payment_date).format("HH:mm") : ""
                    if (response?.detail_payment) {
                        set_id_meeting_room_payment(response?.detail_payment?.id_meeting_room_payment);
                    }
                    set_currency_option(response?.detail_payment?.currency || "")
                    setFormState((prev) => ({
                        ...prev,
                        meeting_room_payment_date: response?.detail_payment?.meeting_room_payment_date,
                        meeting_room_payment_amount: String(response?.detail_payment?.meeting_room_payment_amount || ""),
                        meeting_room_payment_time: meeting_room_payment_time,
                    }))
                }
                console.log(response, 'response')
            }
        }).catch((err) => {
            console.log(err)
        })
    }

    const uploadFilePromise = async (files: File[]): Promise<number[]> => {
        dispatch(setLoading());
        const form_data = new FormData();
        files.forEach((file) => {
            form_data.append('files', file);
        })
        return await BookingMeetingRoomFront.uploadMultiFile(form_data).then((res) => {
            if (res.status < 300) {
                return res?.data?.map((list: { id_meeting_room_file: number }) => {
                    return list?.id_meeting_room_file
                })
            } else {
                return []
            }
        }).catch((err) => {
            console.log(err)
        }).finally(() => {
            dispatch(unsetLoading())
        })
    }
    const generateBody = async (): Promise<booking_classroom_payment_data> => {
        let full_date: string = "";
        let file_payment_id = payment_file?.length > 0 ? await uploadFilePromise(payment_file?.map((list) => list?.file)) : [];
        if (formState.meeting_room_payment_date && formState.meeting_room_payment_time) {
            full_date = `${moment(formState.meeting_room_payment_date).format("YYYY-MM-DD")}T${formState.meeting_room_payment_time}`;
        }
        if (payment_file_api?.length > 0) {
            const id_file = payment_file_api?.map((list) => list?.id_meeting_room_file);
            file_payment_id.unshift(...id_file)
        }
        return {
            currency: currency_option,
            id_files_payment: file_payment_id,
            id_meeting_room,
            meeting_room_payment_amount: formState.meeting_room_payment_amount ? Number(formState.meeting_room_payment_amount) : 0,
            meeting_room_payment_date: full_date,
        }
    }

    const handleSubmitPayment = async (id_meeting_room_payment?: number | null) => {
        const body = await generateBody();
        dispatch(setLoading());
        if (id_meeting_room_payment) {
            await BookingMeetingRoomFront.updatePayment(id_meeting_room_payment, body).then((res) => {
                if (res.status < 300) {
                    navigate(routeName.public.classroom_meeting_booking);
                    alertSuccess(t("บันทึกข้อมูลการชำระเงิน"), t("บันทึกข้อมูลการชำระเงิน เรียบร้อยแล้วกรุณารอทางเจ้าหน้าที่ตรวจสอบข้อมูล"))
                }
            }).catch((err) => {
                console.log(err);
                alertError(t("บันทึกข้อมูลการชำระเงิน"), t("บันทึกข้อมูลการชำระเงิน ไม่สำเร็จ"))
            }).finally(() => {
                dispatch(unsetLoading());
            })
        } else {
            await BookingMeetingRoomFront.sendPayment(body).then((res) => {
                if (res.status < 300) {
                    navigate(routeName.public.classroom_meeting_booking);
                    alertSuccess(t("บันทึกข้อมูลการชำระเงิน"), t("บันทึกข้อมูลการชำระเงิน เรียบร้อยแล้วกรุณารอทางเจ้าหน้าที่ตรวจสอบข้อมูล"))
                }
            }).catch((err) => {
                console.log(err);
                alertError(t("บันทึกข้อมูลการชำระเงิน"), t("บันทึกข้อมูลการชำระเงิน ไม่สำเร็จ"))
            }).finally(() => {
                dispatch(unsetLoading());
            })
        }

    }

    useEffect(() => {
        handleGetBookingMeetingRoomFrontPayment();
    }, [])

    return (
        <Box className='w-full my-4'>
            <Box className="grid grid-cols-12 gap-4">
                <BoxCustom className='col-span-12 xl:col-span-4'>
                    <PaymentChannelStatus
                        payment_icon_url={payment_icon_url}
                        payment_name={payment_name}
                        payment_name_en={payment_name_en}
                        payment_no={payment_no}
                        payment_type={payment_type}
                    />
                </BoxCustom>
                <BoxCustom className='col-span-12 xl:col-span-4'>
                    <Typography my={2} fontWeight={800} variant='h5'>
                        {t("รายการที่ต้องชำระ")}
                    </Typography>
                    <StateComponents
                        typeProps={[
                            {
                                seq: 1,
                                type: "SELECT",
                                gridProps: {
                                    xs: 12,
                                },
                                fieldProps: {
                                    labelId: "ss",
                                    heading: t("สกุลเงิน"),
                                    disabled: disabled,
                                    placeholder: t("ระบุ"),
                                    onChange: (e) => {
                                        set_currency_option(e.target.value);
                                        // handleChange('form_type', index, e.target.value);
                                    },
                                    options: currency_options,
                                    selectId: "SS",
                                    value: currency_option,
                                }
                            },
                        ]}
                    />
                    <div className='grid grid-cols-12 gap-2 mt-6'>
                        {[t('รายการที่ต้องชำระ'), t('จำนวน'), t('ค่าบริการ/หน่วย'), t('ค่าบริการรวม')].map((list) => {
                            return (
                                <span className='col-span-3'>
                                    <Typography variant='h6'>{list}</Typography>
                                </span>
                            )
                        })}
                        {data_detail?.map((list, i) => {
                            return <>
                                <span className={clsx('col-span-3', {
                                })}>
                                    <Typography>
                                        {`${i + 1}.${list?.name}`}
                                    </Typography>
                                </span>
                                <span className='col-span-3'>
                                    <Typography>
                                        {list?.qty || "-"}
                                    </Typography>
                                </span>
                                <span className='col-span-3'>
                                    <Typography>
                                        {currency_option === CURRENCY.THB ? list?.price_thb || "-" : list?.price_usd || "-"}
                                    </Typography>
                                </span>
                                <span className='col-span-3'>
                                    <Typography>
                                        {currency_option === CURRENCY.THB ? list?.sum_thb || "-" : list?.sum_usd || "-"}
                                    </Typography>
                                </span>
                                {i !== data_detail?.length - 1 && (
                                    <span className='col-span-12 my-2'>
                                        <Divider
                                            sx={{
                                                width: "100%",
                                                borderStyle: "dotted",
                                                borderWidth: "1px",
                                                borderColor: "rgba(0,0,0,0.3)",
                                            }}
                                        />
                                    </span>
                                )}
                            </>
                        })}
                        <span className='col-span-12 my-4'>
                            <Divider
                                sx={{
                                    width: "100%",
                                    borderStyle: "dotted",
                                    borderWidth: "1px",
                                    borderColor: "rgba(0,0,0,0.3)",
                                }}
                            />
                        </span>
                    </div>
                    <Box className="flex justify-between items-center col-span-12">
                        <Typography sx={{ color: "#F79009" }} variant='h6'>{t("ราคารวมทั้งหมด")}</Typography>
                        <Typography sx={{ color: "#F79009" }} variant='h5'>
                            {Number(data_detail?.reduce((x, y) => x + Number(currency_option === CURRENCY.THB ? (y?.sum_thb || 0) : (y?.sum_usd || 0)), 0)).toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                            })}
                        </Typography>
                    </Box>
                </BoxCustom>
                <BoxCustom className='col-span-12 xl:col-span-4'>
                    <Typography my={2} fontWeight={800} variant='h5'>
                        {t("หลักฐานการชำระเงิน")}
                    </Typography>
                    <ImageTracking
                        handleDeleteImageApi={(_, i) => {
                            handleDeleteByFileByIndex(i, true)
                        }}
                        handleDeleteImageSelect={(_, i) => handleDeleteByFileByIndex(i)}
                        onChange={handleChangePaymentFile}
                        disabled={disabled}

                        tabIndex={0}
                        valueAddFile={payment_file}
                        valueImage={payment_file_api}
                    />
                </BoxCustom>
            </Box>
            <StateComponents
                disabledAllField={disabled}
                otherProps={{ spacing: 2 }}
                sxContainer={{ my: 2 }}
                typeProps={[
                    {
                        seq: 1,
                        gridProps: {
                            xs: 12,
                            md: 3
                        },
                        type: "DATE",
                        fieldProps: {
                            heading: t("วันที่ชำระเงิน"),
                            placeholder: t("ระบุ"),
                            onChange: (e) => handleChangeFormState('meeting_room_payment_date', e),
                            value: formState.meeting_room_payment_date
                        }
                    },
                    {
                        seq: 2,
                        gridProps: {
                            xs: 12,
                            md: 3
                        },
                        type: "TIME_PICKER",
                        fieldProps: {
                            heading: t("เวลาชำระเงิน"),
                            onChange: (e) => handleChangeFormState('meeting_room_payment_time', e),
                            value: formState?.meeting_room_payment_time || ""
                        }
                    },
                    {
                        seq: 4,
                        type: "SELECT",
                        gridProps: {
                            xs: 12,
                            md: 1.5
                        },
                        fieldProps: {
                            labelId: "ss",
                            heading: t("สกุลเงิน"),
                            placeholder: t("ระบุ"),
                            onChange: (e) => {
                                set_currency_option(e.target.value);
                            },
                            options: currency_options,
                            selectId: "SS2",
                            value: currency_option,
                        }
                    },
                    {
                        seq: 5,
                        gridProps: {
                            xs: 12,
                            md: 3
                        },
                        type: "TEXT-MASK",
                        fieldProps: {
                            mode: "amount",
                            heading: t("จำนวนยอดเงิน ({{currency}})", { currency: currency_option }),
                            onChange: (e) => handleChangeFormState('meeting_room_payment_amount', e.target.value),
                            value: String(formState?.meeting_room_payment_amount || "")
                        }
                    },
                    {
                        seq: 6,
                        type: "SELECT",
                        gridProps: {
                            xs: 12,
                            md: 1.5
                        },
                        fieldProps: {
                            labelId: "ss",
                            heading: t("ประเภทหลักฐาน"),
                            placeholder: t("ระบุ"),
                            onChange: () => {
                            },
                            disabled: true,
                            options: [{ label: t("แนบสลิป"), value: t("แนบสลิป") }],
                            selectId: "SS2",
                            value: t("แนบสลิป"),
                        }
                    },
                ]}
            />

            {!hidden_button && (
                <Box my={2} className="flex justify-center items-center gap-4">
                    <Button onClick={() => navigate(routeName.public.classroom_meeting_booking)} variant='outlined' >{t("ย้อนกลับ")}</Button>
                    {!disabled && (
                        <Button onClick={() => handleSubmitPayment(id_meeting_room_payment)} variant='contained' color='success'>{t("ยืนยัน")}</Button>
                    )}
                </Box>
            )}
        </Box>
    )
}

export default PaymentBookingMeetingRoom